import { ActivePathActionTypes, SET_ACTIVE_PATH } from "../types/actions";

const activePathReducerDefaultState: string =  '/home'; 

const activePathReducer = (state : string = activePathReducerDefaultState, action : ActivePathActionTypes) : string => {
    switch (action.type) {
        case SET_ACTIVE_PATH:
            return action.path;
        default:
            return state;
    }
}

export default activePathReducer